export default {
  order_status_toast: {
    order_reviewed: '#{{number}} Je bestelling is gezien',
    order_confirmed: '#{{number}} Bevestigde tijd {{time}}',
    order_preparation_up_time_changed: '#{{number}} {{type}} tijd gewijzigd naar {{time}}',
    serving_time_changed: '#{{number}} Je bestelling wordt om {{time}} geserveerd',
    order_preparing: 'Je bestelling #{{number}} wordt bereid',
    order_rejected: '#{{number}} bestelling geweigerd',
  },
  order_type: {
    pickup: 'Afhalen',
    delivery: 'Bezorging',
  },
};
